import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { SETTINGS_SHADOW_SM } from './settingsStyles';

export const mailboxTabStyles = StyleSheet.create({
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: 16,
		marginBottom: 6,
	},
	title: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: 24,
		fontWeight: 600,
		margin: 0,
		color: THEME.colors.text.main,
	},
	newButton: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 7,
	},
	lead: {
		fontSize: 14,
		color: THEME.colors.text.light,
		marginBottom: 20,
	},
	grid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
		gap: 16,
	},
	card: {
		display: 'flex',
		flexDirection: 'column' as const,
		gap: 14,
		backgroundColor: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: 14,
		boxShadow: SETTINGS_SHADOW_SM,
		padding: '18px 20px',
	},
	cardInactive: {
		opacity: 0.72,
	},
	cardTop: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		gap: 10,
	},
	cardInfo: {
		minWidth: 0,
	},
	name: {
		fontSize: 16,
		fontWeight: 600,
		color: THEME.colors.text.main,
	},
	emailAddress: {
		fontSize: 13,
		color: THEME.colors.text.light,
		marginTop: 2,
		whiteSpace: 'nowrap' as const,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	statusPill: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 5,
		flexShrink: 0,
		fontSize: 11,
		fontWeight: 500,
		borderRadius: 18,
		padding: '3px 10px',
	},
	statusActive: {
		color: THEME.colors.success.dark,
		backgroundColor: THEME.colors.success.light,
	},
	statusDot: {
		width: 6,
		height: 6,
		borderRadius: '50%',
		backgroundColor: THEME.colors.success.dark,
	},
	statusInactive: {
		color: THEME.colors.text.light,
		backgroundColor: THEME.colors.pill.gray.background,
	},
	cardFooter: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		paddingTop: 6,
		borderTop: `1px solid ${THEME.colors.border.light}`,
	},
	deactivateButton: {
		marginLeft: 'auto',
		color: THEME.colors.danger.main,
	},
	emptyState: {
		padding: 32,
		textAlign: 'center' as const,
		color: THEME.colors.text.light,
		fontSize: 14,
		backgroundColor: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: 14,
		boxShadow: SETTINGS_SHADOW_SM,
	},
	errorMsg: {
		marginBottom: 12,
	},
});
